import { config } from 'config';

export const getLookerReportDownloadUrl = (campaignId: number) => {
  return `${config.api.baseUrl}/v1/campaigns/${campaignId}/looker-pdf-report`;
};
